import moment from 'moment';

/**
 * Calculate how many minutes old the data is
 * @param {string} dataFrom - ISO timestamp of when data was fetched
 * @param {string} now - Current ISO timestamp
 * @returns {number} Minutes since data was fetched
 */
export function calculateDataFreshness(dataFrom, now) {
  if (!dataFrom) return '';
  const seconds = moment(now).unix() - moment(dataFrom).unix();
  if (seconds < 0) {
    return 0;
  }
  return seconds / 60;
}

/**
 * Get current weekday name
 * @param {string} now - ISO timestamp
 * @returns {string} Weekday name
 */
export function getWeekdayName(now) {
  return moment(now).format('dddd');
}
